import { Dropdown } from "react-bootstrap";
import styles from "./paymentfilter.module.css";
import { Calendar, ChevronDown, Plus, Printer, Search } from "react-feather";
import { DateRangePicker } from "rsuite";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import axios from "axios";
import RentRollPrintView from "../RentRollPrintView";

const predefinedRanges = [{
    label: 'Last 30 Days',
    value: [dayjs().subtract(30, 'day').toDate(), dayjs().toDate()]
}, {
    label: 'Last 60 Days',
    value: [dayjs().subtract(60, 'day').toDate(), dayjs().toDate()]
}, {
    label: 'Last 90 Days',
    value: [dayjs().subtract(90, 'day').toDate(), dayjs().toDate()]
}];

const PaymentFilter = ({ rentRollData, data, propertyId, setAddPaymentModalShow, setAddBillModalShow, setAddCreditModalShow, setIsUpdate, setEditId, filterData, setFilterData, dateFilterData, setDateFilterData }) => {
    const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();
    const [filterText, setFilterText] = useState("All");
    const [propertyDetails, setPropertyDetails] = useState(null);
    const [filterredData, setFilterredData] = useState([]);

    const printRef = useRef();
    const handlePrint = useReactToPrint({
        contentRef: printRef,
        documentTitle: `Rent Ledger - ${rentRollData?.tenant_name || "Report"}`,
        pageStyle: `
        @page {
          size: auto;
          margin: 15mm 10mm 10mm 10mm !important;
        }
        body {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
          background: #fff !important;
        }
        html {
          background: #fff !important;
        }
      `,
    });

    useEffect(() => {
        const fetchPropeetyDetails = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            await axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/property-details/" + propertyId, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setPropertyDetails(response.data.data);
            });
        };
        if (propertyId)
            fetchPropeetyDetails();
    }, [propertyId, getAccessTokenSilently]);

    useEffect(() => {
        const transactions = [...data].flatMap(group => [...group.transactions]).map(i => {
            return i;
        });
        setFilterredData(transactions);
    }, [data]);

    return (<div className={`${styles.ButtonArea}`}>
        <div className={`${styles.ButtonAreaUnder}`}>
            <div className={`${styles.FilterSearchSec}`}>
                <div className={`${styles.NotesSearchMain}`}>
                    <Search />
                    <input type="text" placeholder="Search" className={`${styles.searchInput}`} onChange={(e) => setFilterData((prev) => { return { ...prev, searchKey: e.target.value }; })} />
                </div>
                <Dropdown>
                    <Dropdown.Toggle className={`${styles.ActionsBULine} ActionsBULine`} id="dropdown-basic">Show: {filterText} <ChevronDown /></Dropdown.Toggle>

                    <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                        <FormGroup row className={`${styles.CheckFilter}`}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="checkedE"
                                        color="primary"
                                        indeterminate={!(filterData?.payment_type?.indexOf("bill") > -1 && filterData?.payment_type?.indexOf("credit") > -1 && filterData?.payment_type?.indexOf("payment") > -1) && (filterData?.payment_type?.indexOf("bill") > -1 || filterData?.payment_type?.indexOf("credit") > -1 || filterData?.payment_type?.indexOf("payment") > -1)}
                                        checked={filterData?.payment_type?.indexOf("bill") > -1 && filterData?.payment_type?.indexOf("credit") > -1 && filterData?.payment_type?.indexOf("payment") > -1}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setFilterData((prev) => {
                                                    return { ...prev, payment_type: ["bill", "credit", "payment"] };
                                                });
                                                setFilterText("All");
                                            } else {
                                                setFilterData((prev) => {
                                                    return { ...prev, payment_type: [] };
                                                });
                                                setFilterText("None");
                                            }
                                        }}
                                    />
                                }
                                label="All"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="checkedF"
                                        color="primary"
                                        checked={filterData?.payment_type?.indexOf("bill") > -1}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setFilterData((prev) => {
                                                    let paymentTypeTemp = prev?.payment_type;
                                                    if (paymentTypeTemp?.indexOf("bill") === -1) {
                                                        paymentTypeTemp.push("bill");
                                                    }
                                                    return { ...prev, payment_type: paymentTypeTemp };
                                                });
                                            } else {
                                                setFilterData((prev) => {
                                                    let paymentTypeTemp = prev?.payment_type;
                                                    if (paymentTypeTemp?.indexOf("bill") > -1) {
                                                        paymentTypeTemp.splice(paymentTypeTemp?.indexOf("bill"), 1);
                                                    }
                                                    return { ...prev, payment_type: paymentTypeTemp };
                                                });
                                            }
                                            if (filterData?.payment_type?.length === 3) {
                                                setFilterText("All");
                                            } else if (filterData?.payment_type?.length === 0) {
                                                setFilterText("None");
                                            } else {
                                                setFilterText(filterData?.payment_type?.length + " Selected");
                                            }
                                        }}
                                    />
                                }
                                label="Bills"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="checkedG"
                                        color="primary"
                                        checked={filterData?.payment_type?.indexOf("credit") > -1}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setFilterData((prev) => {
                                                    let paymentTypeTemp = prev?.payment_type;
                                                    if (paymentTypeTemp?.indexOf("credit") === -1) {
                                                        paymentTypeTemp.push("credit");
                                                    }
                                                    return { ...prev, payment_type: paymentTypeTemp };
                                                });
                                            } else {
                                                setFilterData((prev) => {
                                                    let paymentTypeTemp = prev?.payment_type;
                                                    if (paymentTypeTemp?.indexOf("credit") > -1) {
                                                        paymentTypeTemp.splice(paymentTypeTemp?.indexOf("credit"), 1);
                                                    }
                                                    return { ...prev, payment_type: paymentTypeTemp };
                                                });
                                            }
                                            if (filterData?.payment_type?.length === 3) {
                                                setFilterText("All");
                                            } else if (filterData?.payment_type?.length === 0) {
                                                setFilterText("None");
                                            } else {
                                                setFilterText(filterData?.payment_type?.length + " Selected");
                                            }
                                        }}
                                    />
                                }
                                label="Credits"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="checkedH"
                                        color="primary"
                                        checked={filterData?.payment_type?.indexOf("payment") > -1}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setFilterData((prev) => {
                                                    let paymentTypeTemp = prev?.payment_type;
                                                    if (paymentTypeTemp?.indexOf("payment") === -1) {
                                                        paymentTypeTemp.push("payment");
                                                    }
                                                    return { ...prev, payment_type: paymentTypeTemp };
                                                });
                                            } else {
                                                setFilterData((prev) => {
                                                    let paymentTypeTemp = prev?.payment_type;
                                                    if (paymentTypeTemp?.indexOf("payment") > -1) {
                                                        paymentTypeTemp.splice(paymentTypeTemp?.indexOf("payment"), 1);
                                                    }
                                                    return { ...prev, payment_type: paymentTypeTemp };
                                                });
                                            }
                                            if (filterData?.payment_type?.length === 3) {
                                                setFilterText("All");
                                            } else if (filterData?.payment_type?.length === 0) {
                                                setFilterText("None");
                                            } else {
                                                setFilterText(filterData?.payment_type?.length + " Selected");
                                            }
                                        }}
                                    />
                                }
                                label="Payments"
                            />
                        </FormGroup>
                    </Dropdown.Menu>
                </Dropdown>
                <div className={`${styles.DashFilterSec} DashFilterSec RentRoll Filter`}>
                    <DateRangePicker
                        format={"M/d/yy"}
                        placeholder={"Filter by date"}
                        placement={"bottomEnd"}
                        caretAs={Calendar}
                        showOneCalendar
                        ranges={predefinedRanges}
                        value={dateFilterData && Array.isArray(dateFilterData) ? dateFilterData : null}
                        onChange={(e) => setDateFilterData(e)}
                    />
                </div>
            </div>

            <button className={`${styles.PrintBU}`} onClick={handlePrint}><Printer /> Print Ledger</button>

            <div style={{ display: 'none' }}>
                <RentRollPrintView
                    ref={printRef}
                    rentRollData={rentRollData}
                    rentList={filterredData}
                    propertyDetails={propertyDetails}
                />
            </div>


            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("income:create") > -1 && <Dropdown>
                <Dropdown.Toggle className={`${styles.ActionsBU} ${styles.Red} ActionsBU Red`} id="dropdown-basic">
                    <Plus /> <span className={`${styles.AddBuText}`}>New</span>
                </Dropdown.Toggle>

                <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                    <Dropdown.Item className={`${styles.ActionsBUListItem}`} onClick={(e) => { setAddBillModalShow(true); setIsUpdate(false); setEditId(0); }}>
                        <img src="/static/img/bill-icon.svg" alt="" />Bill
                    </Dropdown.Item>
                    <Dropdown.Item className={`${styles.ActionsBUListItem}`} onClick={(e) => { setAddCreditModalShow(true); setIsUpdate(false); setEditId(0); }}>
                        <img src="/static/img/credit-icon.svg" alt="" />Credit
                    </Dropdown.Item>
                    <Dropdown.Item className={`${styles.ActionsBUListItem}`} onClick={(e) => { setAddPaymentModalShow(true); setIsUpdate(false); setEditId(0); }}>
                        <img src="/static/img/bank-icon.svg" alt="" />Payment
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>}
        </div>
    </div>);
}

export default PaymentFilter;